export const BACKGROUND_INFO_SECTION_COPY = {
  title: "Background Information",
  action: "Edit background info",
};
